const ShipmentState = {
  DATA_PROCESSED: 'DATA_PROCESSED',
  SHIPMENT_SORTED: 'SHIPMENT_SORTED',
  SHIPMENT_SORTED_AT_SUB_DEPOT: 'SHIPMENT_SORTED_AT_SUB_DEPOT',
  SHIPMENT_ACCEPTED_BY_DRIVER: 'SHIPMENT_ACCEPTED_BY_DRIVER',
  SHIPMENT_DELIVERED: 'SHIPMENT_DELIVERED',
  SHIPMENT_DELIVERED_TO_NEIGHBOR: 'SHIPMENT_DELIVERED_TO_NEIGHBOR',
  SHIPMENT_NOT_DELIVERED: 'SHIPMENT_NOT_DELIVERED',
  RETURN_SHIPMENT_TO_SENDER: 'RETURN_SHIPMENT_TO_SENDER',
  EXCEPTION_SHIPMENT_NOT_ARRIVED: 'EXCEPTION_SHIPMENT_NOT_ARRIVED',
  EXCEPTION_SHIPMENT_DECLINED_BY_DRIVER:
    'EXCEPTION_SHIPMENT_DECLINED_BY_DRIVER',
  EXCEPTION_SHIPMENT_CANCELLED_BY_SENDER:
    'EXCEPTION_SHIPMENT_CANCELLED_BY_SENDER',
  EXCEPTION_SHIPMENT_CANCELLED_BY_TRUNKRS:
    'EXCEPTION_SHIPMENT_CANCELLED_BY_TRUNKRS',
  EXCEPTION_SHIPMENT_INVESTIGATE: 'EXCEPTION_SHIPMENT_INVESTIGATE',
} as const

type ShipmentStateKeys = (typeof ShipmentState)[keyof typeof ShipmentState]

export default ShipmentState
export type { ShipmentStateKeys }
